module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uFkD8oFjHSKSVyL4k2rpY6C",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_c('a', {
    attrs: {
      "id": "ukDDj4Fqrrn3Ka2a6NAhbM4"
    }
  }), _vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("THE HUNT")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The headaches gnawed at his temples. The sunglasses filtered the harsh light that pierced his eyeballs. Some days, he holed up in his bedroom riding out these waves of pain. At night he worked at his job in the dimly lit theater, still wearing sunglasses. He was warned that his work was getting sloppy. More pressing thoughts niggled in his mind. Although he showed up for work, the quality of his job performance finally got him fired.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Somewhat peeved, yet somewhat relieved, he had more time to pursue his passion. He was free to travel around. He was free to start a construction project he dreamed of building in his apartment. He was free to pursue his “master plan.”")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("Friday Morning, January 7, 1994")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Holiday season over, the tedium of long, cold, gray, snowy months lay ahead. The plows and sanders were out early to stay ahead of the snow not enough to shut down schools, just enough to cast a foreboding dullness.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Usually groggy after filling in for a colleague on the midnight to seven shift at the hospital, nursing assistant Russell Davis’s adrenaline was pumping. Called upon to administer CPR to a patient in cardiac arrest just prior to the end of his shift, he left Berkshire Medical Center as the darkness lifted. Forgetting to remove his glasses, which he usually wore just for night driving and work, he stepped out into the frigid blast of a New England January morning and headed home to see his young sons off to school.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/divider.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At 6:55 AM, while dropping off his son at Reid Middle School located on North St. (aka Rte. 7) just north of downtown, William Mullett noticed a dark pickup truck with a white cab parked on the north side of the building. At this early hour, it was unusual to see people around the school. According to the direction the pickup truck faced, it appeared as though the truck had circled around the back of the building parking facing upper North St. As Mr. Mullett pulled farther into the driveway, the driver started up his truck, driving past the Mulletts. According to Mr. Mullett, as he passed by in his car the truck driver looked away “as if he didn’t want us to see who he was.” In just the short time he saw the driver, William Mullett noticed that the man was scruffy looking, with facial hair slightly graying, was of medium build, and was wearing wire-framed glasses. Mullett asked his son if he had ever seen this truck before, to which the son said no. The pickup truck abruptly exited the driveway, heading south toward the center of Pittsfield.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/divider.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Kenneth Card arrived at work just before 7:00 AM. That morning he dropped his wife Lois off at work, not wanting her to drive in the early morning snow. Ken, who worked for Scarafoni Property Management, immediately started snow blowing the sidewalk in front of the Fleet Bank at the corner of West and North Streets. He then worked his way down West Street to the KB Toys headquarters, wanting to have the walks cleared when the bank and the KB employees arrived for work.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/divider.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Berkshire Hilton stood on the corner of West and South Streets, across the street from the KB Toys headquarters. At 7:00 AM, groundskeeper Guy Harris was out shoveling snow from the sidewalk in front of the hotel when something caught his eye. A black pickup truck with a white cab made its way, unusually slowly, up the West Street hill. Reaching the intersection with South Street, the driver turned right.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A few minutes later, the same truck again ascended the hill very slowly, although the weather conditions did not seem to warrant such caution. As the truck stopped at the traffic light, out of curiosity, Mr. Harris noted the GM logo on the back of the truck and that there was just one person in the vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/divider.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In 1989, Janie Ray was taking care of a young girl while on the job working for the Berkshire County ARC, an organization that provided a wide range of services for persons with disabilities. At that time, she met the cabulance driver who picked the child up each day. After the girl died that year, Janie no longer saw the driver until three years later, when she started dating her boyfriend, Phil Shallies.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Staying at Phil’s house, Janie woke up at 7:15 to get ready to go to work. Besides her job with BARC, she was a well-known videographer who worked with several Berkshire nonprofits and organizations. That morning, she had an 8:00 appointment to film animals for adoption at the Humane Society. While waiting for her curling iron to heat up, she asked Phil to press the button on the answering machine for the time, which was 7:30. She hurried outside to start up her car and to grab the newspaper. While outside, she saw Phil’s friend, the former cabulance driver, returning Phil’s pickup truck that he had borrowed the previous day. She waved to him as he got out of the truck that was backed into the lower driveway on the Shallieses’ property. She invited him in, but he wanted to shovel the upper driveway where his inoperable van and Janie’s car were parked. Waiting for him to finish shoveling made her slightly late for work.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Phil Shallies lived in Lanesboro, Massachusetts with his mother, Sarah “Sally,” Phil’s Aunt Eleanor Turner, and Eleanor’s boyfriend and tenant, Chester “Chet” Forfa. Phil often loaned his truck to his friend, whose decrepit van sat in Phil’s upper driveway broken down, waiting for Phil to patch it together, administering frequent repairs.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This fellow ingratiated his way into a friendship with the Shallies family. Starting out slowly, upon referral, this new customer took his van to Phil Shallies, who worked as an auto mechanic from his home garage. Phil, who was blind, had an exceptional talent for fixing cars. Despite his lack of vision, he used his other senses to diagnose and repair cars. Phil could feel his way around a vehicle and listen to the subtle sounds of the engine to determine the problem.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The well-worn, often broken-down van frequently sat in the Shallieses’ driveway waiting for Phil to patch it together. In exchange for the auto maintenance, the customer worked side by side with Phil doing household repairs and transporting Phil and the elderly ladies to appointments, using Phil’s pickup truck or Chester Forfa’s sedan. Like Phil, his mother was blind and most appreciative of the help this man offered. He was a godsend.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("The Time Was Right")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At 7:00, Rebecca “Becky” Savarese, a twelve-year-old seventh grader at Notre Dame Middle School, headed out the door of her apartment in a mixed income apartment complex where she lived with her single mom, Christine Paoli. Each morning, Rebecca made the one-mile trek to Notre Dame Middle School through well trafficked, downtown Pittsfield.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bundled up in her ski jacket, carrying her purple LL Bean backpack, earplugged into her Walkman, this slender, fair complexioned preteen with curly brown hair, braces on her teeth, and wire-rimmed glasses made her daily walk to school, totally absorbed in the music of the Smashing Pumpkins. Rebecca turned right from the driveway of Riverview West Apartments onto West Street, passing Berkshire Gas Company, then crossing the street in front of the Salvation Army, past the Big Y supermarket, up the hill approaching the corner of West and North Streets, the exact center of town where North, South, East, and West Streets converged at the city’s central rotary.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Notre Dame, a small Catholic school, was located just off North Street, the main thoroughfare and shopping district in the heart of the city. On the corner of North and Melville Streets stood the Pittsfield YMCA. Around the corner on Melville Street buzzed the hub of youth activity at the Notre Dame Middle School, St. Joseph’s High School, the Boys’ Club, and the CYC (Catholic Youth Center), all on one short block.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/divider.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("While at Big Y supermarket, he spotted Rebecca Savarese walking east toward the center of Pittsfield on her way to school. He felt he had a relationship with the preteen. He had often seen her and her friends’ comings and goings from school and about town. He followed the young people, cataloguing their whereabouts and their patterns of movement. Rebecca was alone, seemingly distracted, and the first youngster he had seen that morning. He was more than ready to make his move. Getting in his truck, he drove in the opposite direction from where he had been seen earlier. Circling around, he parked in front of the bank on North Street near the intersection with West Street.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/divider.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Walking up West Street, as Rebecca approached North Street, a scruffy-looking man with a mustache walked past her, then suddenly appeared alongside of her. He warned her, “Do you see the gun I have?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“At first, I thought he was just joking,” Becky told authorities. “He seemed like a nerd to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He approached her, a yellow shirt draped over his arm, and came even closer to her. Coaxing her up to North Street with a gun pointing at her ribs, he commanded, “Do everything I say, and everything will be all right. See that black pickup? I want you to get into it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As the kidnapper led her up the street to his truck, Becky remembered the words her mother repeated to her daily: "), _c('span', {
    staticClass: "Basic_italics"
  }, [_vm._v("“Becky, you stay on the main road and walk where it’s well traveled. If anyone is behind you, duck into a business—kick, bite, scream, punch, spit—anything to get attention.”")]), _c('span', {
    staticClass: "Footnote-reference _idGenCharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-004-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_02#footnote-004"
    }
  }, [_vm._v("4")])])]), _vm._v(" Fearing for her life, Becky later said, “I was afraid if I got into the truck, I would never see my mom again. I would be lying in some ditch dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Within feet of the truck, Rebecca suddenly pretended to hyperventilate, faking an asthma attack. Breathlessly, she asked her attacker, “Can I sit down for a minute?” This stellar performance from a child who never had asthma was enough to catch the kidnapper off guard. As she began to sit down, the kidnapper felt a jerk on his hand as she wiggled loose from the backpack. The split second it took her to slip her arms out of her backpack, she took off running down West Street, leaving him holding the backpack. She flagged down Kenneth Card as he cleared the sidewalks. He took the agitated girl into his office and immediately called the police.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/divider.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "uZczIP2bEYcRM3U87ViYyWG"
    }
  }), _vm._v("Stopped at the traffic light on North Street, Russell Davis observed something unsettling happening on the sidewalk next to his car. At first, he thought a father and daughter were having a heated argument, although with his car windows up he could not hear what they were saying. However, when this slight young girl freed herself from the man’s grasp and took off running, his curiosity turned to suspicion. Ironically, Russ had just had the discussion with his sons about “stranger danger.” Russ looked directly at the man, who now appeared to realize he was being watched.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As the man calmly walked back to his truck, Russ observed the partial license plate number on the front of the vehicle through his rearview mirror. Fortunately, because Russ had forgotten to take off his glasses, the man’s face and the license plate numbers that he noted were in clear focus. While trying to process what was happening, Russ’s attention was diverted as the truck pulled away, passing him on the right and running two red lights. Convinced that he had witnessed an attempted crime in progress, Russ tried to follow the truck down South Street, losing the suspect as the truck turned left a block away onto East Housatonic Street just as the light turned red. Not being able to follow the truck anymore, Russ looked for a place to stop to call the incident into the police. He did not have to go far before he spotted a police car at the corner Mobile station/Lipton Mart.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Just as Kenneth Card was placing a call to the Pittsfield Police Department, Russell Davis approached Officer Delmont Keyes at the Lipton Mart on South Street. Davis explained that he had just witnessed what he thought was an attempted abduction at the corner of North Street. Within minutes, the Pittsfield Police Department received both calls. The police knew they had a major incident on their hands, but little did they suspect the extent of the event.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("The Man")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was up at 5:30 AM, making himself a pancake breakfast. Leaving the apartment at 5:45, the ride should have taken thirty-five minutes from North Adams south on Rte. 7 to downtown Pittsfield. Being early gave him time to stop off at Reid Middle School before the buses arrived, then proceed to the Pittsfield Big Y supermarket on West Street not long before 7:00. He later claimed that he cashed in $.60 worth of soda cans, although the computer on the recycling machine registered its first deposit of the day at 8:00.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was not unusual for him to borrow his friend Phil’s truck or Phil’s tenant Chet’s car to run errands, to transport the older folks, or to use as a loaner while his van was being repaired. Although the man’s appearance could often be unkempt and his van a mess, he occasionally would return Phil’s truck or Chet’s car in pristine condition, detailing the insides of the loaned vehicles.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What struck Janie and Phil as unusual on this day was how early their friend arrived at their house. He usually rolled in at around 10:00 AM. Occasionally, he would even sleep in his van, which he would park in Phil’s lower driveway, still not waking up and coming into the house until later. Arriving early that snowy morning, he parked Phil’s truck in the lower driveway, threw some snow on the truck, then walked to the upper driveway where he unloaded something from the borrowed truck into his disabled van. He then began to shovel the driveway.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When his friend finished shoveling the driveways, Phil invited him in for breakfast. Phil planned to work on his friend’s van that day, which he did in exchange for the work the customer provided for the Shallies family. The two worked on the van from 10:00 AM to 1:00 PM. The men then borrowed Chester Forfa’s car to head down to Pittsfield to Smith’s Auto Electric to have the coil from the van tested, then to Reddington Auto Parts on Wahconah Street for some wiper blades for Chet’s car, which they installed right there. They returned to Phil’s and worked on the van briefly until lunchtime at about l:45 in the afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("What a Story!")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Patrolman Patrick Barry, the first officer on the scene, escorted Rebecca to the police station.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Shortly after sending her daughter off to school, Chris Paoli received the call from the police that her daughter was safely at the station following an attempted abduction. With their adrenalin pumping, Rebecca’s mother and maternal grandparents, who were an integral part in the upbringing of their granddaughter, rushed right over. The family’s shock was palpable. Due to the surreal circumstances surrounding the incident with her granddaughter, and out of her own fear and wishful disbelief that this incident happened to Becky, Grandma Paoli immediately responded with, “Are you sure she’s not lying?” The family quickly realized the incident was shockingly true.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Detective Joe Collias had recently been transferred to the detective bureau from the juvenile bureau, where he investigated child physical and sexual assaults. He understood the nuances of interviewing children. He recalled that morning. “In the early morning, she came to the police station with her mother. Her mother sat back and let her daughter talk. The girl sat at my desk with me, and she was just this happy kid. And I asked her what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Without giving much detail, she simply said, “I was just walking up West Street. This guy walked along side me, grabbed me and was trying to force me into a van.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Collias replied, “Oh, really.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca said, “And I got away from him. I ran away from him. Then he got in his van and drove away.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Collias stated, “I got up from my chair, took a break, and walked around a bit. I was talking to one of my colleagues. ‘Man, that’s a screwy story. She’s telling me this story as if it’s no big deal.’ Then I got a call at my desk from the dispatcher. A man just reported that he was on his way home from work this morning when he saw something on the corner of North and West Streets. A guy was trying to force a young girl into a van, and she got away.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My jaw dropped to my chest. Are you kidding me? She wasn’t scared or crying. Probably most of it was nervousness because she was smiling. So, I went back and started from the beginning to take a typewritten detailed statement. “")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So, Becky, can you describe the man to me?” Collias probed.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This time, Becky filled in details of her ordeal for Detective Collias. “At first, I thought he was just another weirdo walking downtown. He looked like a nerd who was sloppy. The man was white, maybe in his forties or older. He was a little taller than me, maybe about five-foot-six, and thin. He needed a shave and looked like he had wrinkles on his face. He had glasses with silver frames, a mustache, dark brown hair, and, I think, brown eyes. He was dirty looking with dirty, ratty-looking jeans and clothes. He had on a dark-blue knit cap pulled over his ears, and a dark-blue or green jacket. He had a yellow cloth or shirt over his arm that hid the gun he had poking in my side.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Becky, how did you get away?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I pretended to have an asthma attack. I asked him if I could sit down for a minute. As he was pulling on me, I sort of slumped down, pretending I couldn’t catch my breath. As he pulled, I slipped out of my backpack and ran as fast as I could to the first adult that I saw. The man was plowing snow off the sidewalk. He took me right into his office and called the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What can you tell me about his vehicle?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It was a black pickup truck with a white top over the back end of the truck.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did you ever see that truck before?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yeah. I’ve seen that truck a few times before as I was walking home from school with my friends, and I think at the cinema center.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you remember ever seeing the man before?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Becky, we’re going to need you to work with another officer to put together a picture of the man.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Patricia “Patti” Driscoll was one of the few female Massachusetts State Police in the 1990s who had worked her way up to detective. Assigned to the Massachusetts State Police Crime Prevention and Control Unit housed in the Berkshire County District Attorney’s office, she headed over to the police station with a Smith and Wesson Identikit, referred to by the police as “Mr. Potato Head,” to work with Rebecca to construct a composite sketch of the suspect. Patti guided Rebecca in the task by asking specific questions regarding the perpetrator’s appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The composite was not intended to be an exact picture of the person; rather, as close of a likeness as possible. The questioning usually began with the hair, working the way to the eyes, nose, lips, etc. The features would overlap, refining the overall picture until the likeness was as accurate as possible. Again, Becky performed this challenging task remarkably well. The police wasted no time circulating the composite to all the local law enforcement agencies.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Russell Davis returned to the station after he got his sons off to school to give his account of the incident he had witnessed to the detectives. He had not been sure of what was happening with the young girl and the man until she took off running. He still had his doubts until the truck pulled out into the main intersection in the center of town and recklessly ran two red lights.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Davis caught sight of part of the license plate numbers in his rearview mirror before the truck driver took off. Because he had a mirror image of the license plate, he was unsure if the numbers he saw were the first three or the last three of the license plate. He confirmed Rebecca’s description of the pickup truck as black or dark blue with a white cab.")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("District Attorney Gerard Downing")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Detective Patti Driscoll knocked on Gerard Downing’s office door. Berkshire County District Attorney Gerard Downing and First Assistant DA David Capeless had just returned to the office. Driscoll entered and announced, “We were advised by the Pittsfield Police Department that there was an attempted kidnapping early this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, really? Where?” replied DA Downing.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Patti walked over to the window and pointed to the street below. “She’s a seventh grader at Notre Dame.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Downing asked, “What’s her name and how late was she for school?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Her name is Rebecca Savarese and there was an eyewitness.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Holy crap. That’s one of my son Ben’s classmates.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The shocking audacity of this crime gave pause to the DA as well as to Rebecca’s family.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Timing is everything. Downing and Capeless were just beginning their biggest murder case since taking office three years earlier. Less than two years after becoming DA, Downing and Capeless faced one of the most sensational and highly publicized cases in the history of Berkshire County—the Wayne Lo Case.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Wayne Lo immigrated to the United States from Taiwan at age seven. The Lo family moved back and forth from Taiwan twice before finally settling in Billings, Montana when Wayne was in seventh grade. A brilliant student and accomplished violinist, Wayne received the W.E.B. Dubois Minority Scholarship to Simon’s Rock College of Bard in Great Barrington, Massachusetts.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Simons Rock, an adjunct of Bard College, provided a unique niche educational experience for extremely bright, creative teens who were not best served educationally in a traditional high school. Skipping their junior or senior years in high school, the average age of the students was sixteen. Highly selective students came from all over the country to this nurturing rural campus that offered a liberal learning style with small classes where students and faculty operated on a first name basis.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("On Monday, December 14, 1992, eighteen-year-old college student Wayne Lo traveled by taxi, a forty-five minute ride from his Great Barrington campus to Dave’s Sporting Goods store in Pittsfield, where he easily purchased, on the spot, an SKS semiautomatic assault rifle with no questions asked. He only needed an ID proving he was of legal age. Just days before, he had readily purchased armor-piercing ammunition by mail order using his mother’s credit card. The package marked “ammunition,” delivered to the school, sat in the mail room. Again, no questions were asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Returning to school from Dave’s, Lo loaded the rifle with the armor-piercing ammunition, going on a shooting rampage. Perhaps it was the naiveté of the times, but Wayne Lo’s privacy had priority over the red flags hidden in plain sight. Two days prior to the incident, an unopened package of ammunition from the North Carolina company, Classic Arms, had been delivered to the mail room and brought to the attention of school officials. When questioned, Lo responded that the ammunition was a Christmas gift for his father. Lo’s room was searched, but nothing was found. Bullets were hidden in the weight room of Lo’s dorm. A caller warned the school that Lo had a gun just prior to the shooting."), _c('span', {
    staticClass: "Footnote-reference _idGenCharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-003-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_02#footnote-003"
    }
  }, [_vm._v("5")])])]), _vm._v(" Yet all these warning signs remained unheeded. First Assistant District Attorney David Capeless later pointed out, “The Simon’s Rock shooting was one of the first in the modern wave of school shootings.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The biggest case of District Attorney Gerard Downing’s and Assistant DA David Capeless’s careers was now in its second day. The Wayne Lo case received such a preponderance of pretrial publicity that all parties agreed the defendant could not get a fair trial in Berkshire County. The trial, which had been moved fifty-five miles east to Springfield, MA, presented all sorts of logistical issues. Witnesses included a myriad of former Simon’s Rock students—many of whom were no longer living in Massachusetts—college faculty, Great Barrington Police, local emergency personnel, the gun shop owner, and more. Although jurors were selected from Springfield, everyone else involved with the trial had to be transported back and forth daily.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jury selection began on Thursday, January 6, 1994. Anticipating the process of seating a jury amenable to both the prosecution and the defense would take at least two days, the district attorneys marveled that this task was accomplished in just one day. Well organized plans for the next day were implemented and carried out without a hitch. Jurors were escorted by van to Simons Rock College in Great Barrington to the scene of the crime for a “view.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("On Friday morning the jury, along with the defense and prosecuting attorneys, the judge, and the court reporter retraced the steps taken by Lo on that horrifying day when he went on his shooting rampage. Starting at the security guard gate at the college entrance, Wayne Lo shot guard Teresa Beavers twice in the abdomen at point blank range with an incredibly powerful rifle. Remarkably, she survived. As professor Nacunan Saez drove through the gate, he was shot and killed. As Galen Gibson came out to help, he, too, was shot dead.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lo then moved into the library, where he shot through the card catalogue with the bullet penetrating and embedding into the thigh of Thomas McElderry, who was sitting in the library. Moving on to the dorm, Lo shot and wounded Matthew David and Joshua Faber, who were standing inside a glass enclosed stairwell. Lo then fired at and missed another student. His rampage came to a halt as his gun jammed upon entering the student union. He grabbed a student and ordered him to call the police, and the cops soon arrived. By 11:00 in the morning, Lo had surrendered to the Great Barrington Police without a struggle.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("By noon, the jurors—cold, overwhelmed, and emotionally spent from their outing to Simon’s Rock—were treated to lunch at the Red Lion Inn on Main Street in Stockbridge. This historic inn, featured in Norman Rockwell’s famous painting"), _c('span', {
    staticClass: "Basic_italics"
  }, [_vm._v(" Main Street at Christmas,")]), _vm._v(" gave the jurors the needed respite from their morning ordeal in this tranquil, picture perfect New England setting.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The snow, which had begun early in the morning, was becoming a full-blown blizzard. Rather than taking time out for lunch, District Attorney Downing and Assistant DA Capeless returned to their office in Pittsfield to prepare for the opening day of the Lo trial on the following Monday. They were just beginning to work on the evidence portion of the trial when Detective Driscoll broke the news of the kidnapping to the DAs.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gerard Downing anxiously waited until his son Ben got home from school. Ben remembers his father calling him and saying he needed to talk about something serious. “You may have heard about something with a classmate and we’re trying to check into it. Just tell me something about her.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Of course, the students in Rebecca’s class had heard the news. For this tight knit seventh grade class, a combination of shock, terror, and disbelief permeated the classroom. Ben and Becky had grown up together. Their families both belonged to St. Theresa’s Parish. They had started together at Sacred Heart Elementary School and then gone on to Notre Dame Middle School. Becky was friendly and well-liked by everyone. There was a genuine, no nonsense, no excuses quality about this girl that her classmates instinctively appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“As I walked to school and basketball practice,” Ben reflected, “I never heard my father say anything, but I can imagine his thinking that could easily have been Ben or my sister, Maggie, who is a couple of years younger.” This was hitting too close to home for the district attorney.")]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "footnote-004"
    }
  }, [_c('p', {
    staticClass: "Footnote-text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_02#footnote-004-backlink"
    }
  }, [_vm._v("4")]), _vm._v(". "), _c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("Caldwell, Jean. (January 12, 1994). Drug abuse Resistance Education")]), _c('span', {
    staticClass: "Basic_Bold-Italics"
  }, [_vm._v(". The Boston Globe.")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footnote-003"
    }
  }, [_c('p', {
    staticClass: "Footnote-text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_02#footnote-003-backlink"
    }
  }, [_vm._v("5")]), _vm._v(". "), _c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("Bellow, Heather. (December 17, 2017). Shooting at Bard College at Simon’s Rock/25 Year Later. ")]), _c('span', {
    staticClass: "Basic_Bold-Italics"
  }, [_vm._v("The Berkshire Eagle.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d66dfb46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chap_02.vue
// module id = 84
// module chunks = 0